import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Signal, WritableSignal, computed, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import {
  DialogBase,
  TiimeAlertModule,
  TiimeButtonModule,
  TiimeDialogModule,
  TiimeSnackbarModule,
  TiimeSnackbarService
} from 'tiime-material';

import { CompanyApiService } from '@api-services/company-api.service';
import { DateHelper } from '@helpers/date.helper';

import { SendToLyaDialogData } from './send-to-lya-dialog-data';

@Component({
  selector: 'app-send-to-lya-dialog',
  standalone: true,
  imports: [AsyncPipe, TiimeDialogModule, TiimeButtonModule, TiimeSnackbarModule, TiimeAlertModule],
  templateUrl: './send-to-lya-dialog.component.html',
  styleUrls: ['./send-to-lya-dialog.component.scss', '../../../core/bases/simple-dialog/simple-dialog.base.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SendToLyaDialogDialogComponent extends DialogBase<SendToLyaDialogDialogComponent> {
  readonly dialogData: Signal<SendToLyaDialogData> = signal(inject(MAT_DIALOG_DATA)).asReadonly();
  readonly violations: WritableSignal<string[]> = signal<string[]>([]);
  readonly message: Signal<string> = computed(() => {
    const transferDate: string | null = this.dialogData()?.status?.updatedAt
      ? DateHelper.format(this.dialogData().status.updatedAt, 'DD/MM/YYYY')
      : null;

    return transferDate
      ? `Le dossier a déjà été transféré le ${transferDate}. Un nouvel envoi du dossier vers LYA ne permet pas de mettre à jour les données au sein du logiciel. Voulez-vous continuer ?`
      : `Êtes-vous sûr de vouloir envoyer ce dossier sur Lya ?`;
  });

  constructor(
    dialogRef: MatDialogRef<SendToLyaDialogDialogComponent>,
    private readonly companyApiService: CompanyApiService,
    private readonly snackbar: TiimeSnackbarService
  ) {
    super(dialogRef);
  }

  sendToLya(): void {
    this.violations.set([]);
    this.isLoading.set(true);

    this.companyApiService
      .sendToLya(this.dialogData().companyId)
      .pipe(
        tap(() => {
          this.isLoading.set(false);
          this.snackbar.openSuccess(`Le dossier est en cours d'envoi sur Lya`);
          this.close(true);
        }),
        catchError(err => {
          this.violations.set(err.error?.violations ?? []);
          this.isLoading.set(false);

          return throwError(() => err);
        })
      )
      .subscribe();
  }
}
